"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var main_exports = {};
__export(main_exports, {
  cliMain: () => cliMain
});
module.exports = __toCommonJS(main_exports);
var import_fs = require("fs");
var import_module = require("module");
var import_dev = require("./dev");
const import_meta = {};
async function getLatestVersion(packageName) {
  var require2 = (0, import_module.createRequire)(import_meta.url);
  var _confuseDepCheck = require2;
  var packageJson = _confuseDepCheck("one/package.json");
  var currentVersion = packageJson.version;
  try {
    var response = await fetch(`https://registry.npmjs.org/${packageName}`);
    var data = await response.json();
    var latest = data["dist-tags"].latest;
    if (latest && currentVersion !== latest) {
      console.info(`
\u2776 Update available: ${currentVersion} \u2192 ${latest}`);
      console.info('Run "npx one@latest" or "npm install -g one@latest" to update globally.\n');
    }
  } catch (error) {
    console.error("Failed to fetch the latest version:", error);
  }
}
async function cliMain() {
  var args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  void getLatestVersion("one");
  if ((0, import_fs.existsSync)("vite.config.ts")) {
    await (0, import_dev.dev)({});
    process.exit(0);
  }
  var { create } = await import("create-vxrn/create");
  await create(args);
}
//# sourceMappingURL=main.js.map
